import {MIN_ARTS_TO_CREATE_CAMPAIGN} from '../../../constants/campaignCreation';
import {getArtGenerationAvailability} from '../../../utils/artConsumption';

/**
 * Returns true when the user has enough art balance to start a new campaign.
 */
export async function ensureCampaignCreationAllowed() {
  const availability = await getArtGenerationAvailability(
    MIN_ARTS_TO_CREATE_CAMPAIGN,
    {allowCampaignGeneration: true},
  );

  return availability.hasAvailableArts;
}

export {MIN_ARTS_TO_CREATE_CAMPAIGN};
